module.exports = __webpack_public_path__ + "static/media/mia-malkova.6fe21702.jpg";